import { AxiosClient } from "@/app/shared/services";

const state = {
    notification: {
        settings: {
            sms: [],
            call: [],
        },
        data: {
            by_user: [],
            by_delivery: [],
            all: [],
            sum: [],
            by_chains: [],
        },
        domains: [],
        senders: [],
        isLoading: false,
    },
    modals: {
        userModals: false,
    },
};

const getters = {
    NOTIFICATION_SETTINGS_IS_LOADING: (state) => state.notification.isLoading,
    NOTIFICATION_STAT_GROUP_BY_CHAINS_LOADING: (state) => state.notification.isLoading,
    NOTIFICATION_STAT_GROUP_BY_USER_LOADING: (state) => state.notification.isLoading,
    NOTIFICATION_STAT_GROUP_BY_DELIVERY_LOADING: (state) => state.notification.isLoading,
    NOTIFICATION_STAT_ALL_LOADING: (state) => state.notification.isLoading,
    NOTIFICATION_STAT_SUM_LOADING: (state) => state.notification.isLoading,
    NOTIFICATION_SETTINGS: (state) => state.notification.settings,
    SMS_DOMAINS: (state) => state.notification.domains,
    SMS_SENDERS: (state) => state.notification.senders,
    IS_USER_MODALS_OPENED: (state) => state.modals.userModals,
};

const mutations = {
    SET_SMS_DOMAINS: (state, domains) => {
        state.notification.domains = domains;
    },
    SET_SMS_SENDERS: (state, senders) => {
        state.notification.senders = senders;
    },
    SET_NOTIFICATION_SETTINGS: (state, settings) => {
        state.notification.settings.sms = settings.sms;
        state.notification.settings.call = settings.call;
    },
    SET_NOTIFICATION_STAT_GROUP_BY_USER: (state, data) => {
        state.notification.data.by_user = data.by_user;
    },
    SET_NOTIFICATION_STAT_GROUP_BY_DELIVERY: (state, data) => {
        state.notification.data.by_delivery = data.by_delivery;
    },
    SET_NOTIFICATION_STAT_ALL: (state, data) => {
        state.notification.data.all = data.all;
    },
    SET_NOTIFICATION_STAT_SUM: (state, data) => {
        state.notification.data.sum = data.sum;
    },
    SET_NOTIFICATION_STAT_GROUP_BY_CHAINS: (state, data) => {
        state.notification.data.by_chains = data.by_chains;
    },
    SET_NOTIFICATION_SETTINGS_LOADING: (state, isLoading) => {
        state.notification.isLoading = isLoading;
    },
    SET_NOTIFICATION_STAT_GROUP_BY_USER_LOADING: (state, isLoading) => {
        state.notification.isLoading = isLoading;
    },
    SET_NOTIFICATION_STAT_GROUP_BY_DELIVERY_LOADING: (state, isLoading) => {
        state.notification.isLoading = isLoading;
    },
    SET_NOTIFICATION_STAT_GROUP_BY_CHAINS_LOADING: (state, isLoading) => {
        state.notification.isLoading = isLoading;
    },
    SET_NOTIFICATION_STAT_ALL_LOADING: (state, isLoading) => {
        state.notification.isLoading = isLoading;
    },
    SET_NOTIFICATION_STAT_SUM_LOADING: (state, isLoading) => {
        state.notification.isLoading = isLoading;
    },
    SET_USER_MODALS_OPENED: (state, isOpened) => {
        state.modals.userModals = isOpened;
    },
    CHANGE_IS_USED: (state, notification) => {
        notification.isUsed = !notification.isUsed;
    },
};

const actions = {
    GET_NOTIFICATION_SETTINGS: (context) => {
        context.commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/notification/get_settings")
                .then((data) => {
                    context.commit("SET_NOTIFICATION_SETTINGS", data.data);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
                });
        });
    },
    GET_SMS_INFO: (context) => {
        context.commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/notification/get_sms_info")
                .then((data) => {
                    context.commit("SET_SMS_DOMAINS", data.data.domains);
                    context.commit("SET_SMS_SENDERS", data.data.senders);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
                });
        });
    },
    SAVE_NOTIFICATION_SETTINGS: (context, params) => {
        context.commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/notification/save_settings", params)
                .then(() => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
                });
        });
    },

    CREATE_INSTANT_NOTIFICATION: (context, params) => {
        context.commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/notification/create", params)
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
                });
        });
    },

    DELETE_CHAIN: (context, chainId) => {
        context.commit('SET_NOTIFICATION_SETTINGS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/notification/delete_chain/${chainId}`)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_NOTIFICATION_SETTINGS_LOADING', false);
                });
        });
    },


    UPDATE_INSTANT_NOTIFICATION: (context, params) => {
        context.commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/notification/update/"+params.id, params)
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
                });
        });
    },

    GET_NOTIFICATION_STAT_GROUP_BY_USER: (context, params) => {
        context.commit("SET_NOTIFICATION_STAT_GROUP_BY_USER_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/notification/get_notification_stat_group_by_user", { params })
                .then((data) => {
                    context.commit("SET_NOTIFICATION_STAT_GROUP_BY_USER", data.data);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_STAT_GROUP_BY_USER_LOADING", false);
                });
        });
    },

    GET_NOTIFICATION_STAT_GROUP_BY_DELIVERY: (context, params) => {
        context.commit("SET_NOTIFICATION_STAT_GROUP_BY_DELIVERY_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/notification/get_notification_stat_group_by_delivery", { params })
                .then((data) => {
                    context.commit("SET_NOTIFICATION_STAT_GROUP_BY_DELIVERY", data.data);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_STAT_GROUP_BY_DELIVERY_LOADING", false);
                });
        });
    },

    GET_NOTIFICATION_STAT_ALL: (context, params) => {
        context.commit("SET_NOTIFICATION_STAT_ALL_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/notification/get_notification_stat_all", { params })
                .then((data) => {
                    context.commit("SET_NOTIFICATION_STAT_ALL", data.data);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_STAT_ALL_LOADING", false);
                });
        });
    },

    GET_NOTIFICATION_STAT_SUM: (context, params) => {
        context.commit("SET_NOTIFICATION_STAT_SUM_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/notification/get_notification_stat_sum", { params })
                .then((data) => {
                    context.commit("SET_NOTIFICATION_STAT_SUM", data.data);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_STAT_SUM_LOADING", false);
                });
        });
    },
    GET_NOTIFICATION_STAT_GROUP_BY_CHAINS: (context, params) => {
        context.commit("SET_NOTIFICATION_STAT_GROUP_BY_CHAINS_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/notification/get_notification_stat_group_by_chains", { params })
                .then((data) => {
                    context.commit("SET_NOTIFICATION_STAT_GROUP_BY_CHAINS", data.data);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_STAT_GROUP_BY_CHAINS_LOADING", false);
                });
        });
    },
    USER_MODALS: (context, isOpen) => {
        context.commit("SET_USER_MODALS_OPENED", isOpen);
    },
    UPDATE_NOTIFICATION_IS_USED: (context, notification) => {
        context.commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
        context.commit("CHANGE_IS_USED", notification);
        return new Promise((resolve, reject) => {
            AxiosClient.post(`/notification/change_is_used/${notification.id}`, { isUsed: notification.isUsed })
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
                });
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions,
};
